var map = {
	"./avispace/app/shared/file-download-link/file-download-link.component": [
		97786,
		[
			"src_themes_avispace_app_shared_file-download-link_file-download-link_component_ts"
		]
	],
	"./custom/app/shared/file-download-link/file-download-link.component": [
		63871,
		[
			"src_themes_custom_app_shared_file-download-link_file-download-link_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72834;
module.exports = webpackAsyncContext;